module.exports = __webpack_public_path__ + "img/n15.a8455096.jpg";